import { ICityRegions } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { INewTranslationSettingsStoreConfig } from '@/shared/interfaces/new-translation-settings';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/property-api/regions';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  select: ['id', 'regionName', 'cityoffered.clientId'],
  relations: [
    {
      path: 'cityoffered',
      alias: 'cityoffered',
    },
  ],
};

const defaultGetSingleFilters: IQueryCommandOptions = {};

const translationSettings: INewTranslationSettingsStoreConfig = {
  model: 'regions',
  keys: ['regionName'],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ICityRegions>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
  translationSettings,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'tags/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
